import { Routes, Route, Navigate } from 'react-router-dom'

import DashboardOverview from 'Presentation/Views/Dashboard/Overview/View'
import DashboardOperation from 'Presentation/Views/Dashboard/Operation/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'
import DashboardSummaryView from 'Presentation/Views/Dashboard/Summary/View'

const DashboardRoutes = () => (
  <Routes>
    {/* Route: Dashboard Overview */}
    <Route
      path='overview'
      element={
        <ProtectedRoutePermission whitelist={RolePermissionConfigs.dashboard_overview}>
          <DashboardOverview />
        </ProtectedRoutePermission>
      }
    />
    {/* Route: Dashboard Overview */}

    <Route
      path='summary'
      element={
        <ProtectedRoutePermission whitelist={RolePermissionConfigs.dashboard_overview}>
          <DashboardSummaryView />
        </ProtectedRoutePermission>
      }
    />
    {/* Route: Dashboard Operation */}
    <Route
      path='operation'
      element={
        <ProtectedRoutePermission whitelist={RolePermissionConfigs.dashboard_operation}>
          <DashboardOperation />
        </ProtectedRoutePermission>
      }
    />

    {/* Route: Dashboard Operation */}

    <Route path='*' element={<Navigate to='/home' />} />
  </Routes>
)

export default DashboardRoutes
